<template>
    <div class="no-results">
        <p
            class="h5 title"
            v-test:title
        >
            {{ $snippet('no_results_title') }}
        </p>
        <p
            class="subtitle"
            v-test:subtitle
        >
            {{ $snippet('no_results_subtitle') }}
        </p>
    </div>
</template>

<script>
    export default {
        name: 'no-results',
    };
</script>
